import { fmtNum, PASS_RULES, TOTAL_METHODS } from "@/lib/api";

const Status = ({ v, testid }) =>
  v === null || v === undefined ? <span className="text-slate-400">-</span> : (
    <span data-testid={testid} className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${v ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>{v ? "Memenuhi" : "Belum"}</span>
  );

export const ResultTable = ({ result }) => {
  const showPG = result.subjects.some((s) => s.passing_grade !== null && s.passing_grade !== undefined);
  return (
    <div className="space-y-3">
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="w-full text-sm sm:min-w-[560px]" data-testid="result-table">
          <thead className="bg-[#0A192F] text-left text-xs uppercase tracking-wider text-white">
            <tr>
              <th className="w-10 px-3 py-3">No.</th>
              <th className="px-3 py-3">Materi Ujian</th>
              <th className="hidden px-3 py-3 text-center sm:table-cell">Soal</th>
              <th className="hidden px-3 py-3 text-center sm:table-cell">B / S / K</th>
              {showPG && <th className="hidden px-3 py-3 text-center sm:table-cell">Passing Grade</th>}
              {showPG && <th className="px-3 py-3 text-center">Status</th>}
              <th className="px-3 py-3 text-right">Skor</th>
            </tr>
          </thead>
          <tbody>
            {result.subjects.map((s, i) => (
              <tr key={s.subject_id} className="border-t border-slate-100 odd:bg-white even:bg-slate-50/60" data-testid={`result-row-${i}`}>
                <td className="px-3 py-3 font-semibold text-slate-500">{i + 1}</td>
                <td className="px-3 py-3 font-semibold text-slate-800">{s.name}{s.method === "skor_pilihan" && <span className="ml-2 text-[10px] font-bold uppercase text-amber-600">skor pilihan</span>}{showPG && s.passing_grade != null && <span className="block text-[11px] font-normal text-slate-500 sm:hidden">PG {fmtNum(s.passing_grade)}</span>}</td>
                <td className="hidden px-3 py-3 text-center sm:table-cell">{s.question_count}</td>
                <td className="hidden px-3 py-3 text-center text-slate-600 sm:table-cell">{s.method === "benar_salah" ? `${s.correct} / ${s.wrong} / ${s.blank}` : `– / – / ${s.blank}`}</td>
                {showPG && <td className="hidden px-3 py-3 text-center sm:table-cell">{fmtNum(s.passing_grade)}</td>}
                {showPG && <td className="px-3 py-3 text-center"><Status v={s.passed} testid={`result-row-${i}-status`} /></td>}
                <td className="whitespace-nowrap px-3 py-3 text-right font-mono font-bold text-[#0A192F]" data-testid={`result-row-${i}-score`}>{fmtNum(s.score)}<span className="text-slate-400 font-medium">/{fmtNum(s.max_score)}</span></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t-2 border-amber-400 bg-amber-50">
              <td colSpan={showPG ? 3 : 2} className="px-3 py-4 text-right sm:hidden font-display text-base font-extrabold tracking-wider text-[#0A192F]">TOTAL SKOR</td>
              <td colSpan={showPG ? 6 : 4} className="hidden px-3 py-4 text-right sm:table-cell font-display text-base font-extrabold tracking-wider text-[#0A192F]">TOTAL SKOR</td>
              <td className="whitespace-nowrap px-3 py-4 text-right font-mono text-lg font-extrabold text-[#0A192F]" data-testid="result-total-score">{fmtNum(result.total)}<span className="text-sm text-slate-500">/{fmtNum(result.max_total)}</span></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <p className="text-xs text-slate-500" data-testid="result-method-note">
        Metode Total Skor: <b>{TOTAL_METHODS[result.total_method]}</b>
        {result.total_method === "weighted" ? " — tiap materi dikonversi ke persen (skor ÷ skor maksimal × 100), dikalikan bobot, lalu dirata-ratakan." : " — seluruh skor materi dijumlahkan."}
        {" "}Aturan kelulusan: <b>{PASS_RULES[result.pass_rule]}</b>{result.total_passing_grade !== null && result.total_passing_grade !== undefined ? ` (passing grade total ${fmtNum(result.total_passing_grade)})` : ""}. B/S/K = Benar/Salah/Kosong.
      </p>
    </div>
  );
};

export const PassBadge = ({ passed, big = false }) =>
  passed === null || passed === undefined ? null : (
    <span data-testid="pass-status-badge" className={`inline-flex items-center rounded-full font-extrabold tracking-wider ${big ? "px-5 py-2 text-base" : "px-3 py-1 text-xs"} ${passed ? "bg-emerald-600 text-white" : "bg-red-600 text-white"}`}>
      {passed ? "LULUS" : "TIDAK LULUS"}
    </span>
  );
